import {
    IUnorderedVerticalListItem,
    IUnorderedVerticalListProperties,
    UnorderedVerticalList,
} from '@vfde-brix/ws10/unordered-vertical-list';
import { CmsTariffBenefit } from '../../interface';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { getTooltipProps } from './tooltip.util';
import { decodeHtml } from '@vfde-sails/utils';

const getBenefitItem = (benefit: CmsTariffBenefit): IUnorderedVerticalListItem => ({
    business: NO_PATTERN_BUSINESS_LOGIC,
    stdHeadline: decodeHtml(benefit.headline),
    txtText: benefit.subline,
    stdIcon: benefit.iconName,
    containerTooltip: benefit.tooltip ? getTooltipProps(benefit.tooltip) : undefined,
    optSize: 'default',
});

/**
 * Get props for benefit list
 *
 * @param benefitList - UnorderedVerticalList brix component
 * @param cmsBenefits - CMS configured benefits
 * @returns The updated list items property
 */
export const getBenefitListProps = (
    benefitList: UnorderedVerticalList | null,
    cmsBenefits: CmsTariffBenefit[],
): Partial<IUnorderedVerticalListProperties> => {
    if (!benefitList || !cmsBenefits.length) {
        return {
            listUnorderedVerticalListItems: [],
        };
    }

    const props = benefitList.getProperties();

    props.listUnorderedVerticalListItems = cmsBenefits.map(getBenefitItem);

    return props;
};
